import { useMutation } from "@tanstack/react-query";
import type {
  ForgotPasswordInput,
  ResetPasswordInput,
  ChangePasswordInput,
} from "@shared/validation/auth.schema";
import { apiClient, ApiError } from "./client";

/**
 * Always resolves for any well-formed email — the server deliberately answers
 * identically whether or not the address has an account, so there is nothing
 * here to branch on.
 */
export function useForgotPassword() {
  return useMutation<{ sent: boolean }, ApiError, ForgotPasswordInput>({
    mutationFn: (vars) =>
      apiClient<{ sent: boolean }>("/api/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
  });
}

export function useResetPassword() {
  return useMutation<{ reset: boolean }, ApiError, ResetPasswordInput>({
    mutationFn: (vars) =>
      apiClient<{ reset: boolean }>("/api/auth/reset-password", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
  });
}

export function useChangePassword() {
  return useMutation<{ changed: boolean }, ApiError, ChangePasswordInput>({
    mutationFn: (vars) =>
      apiClient<{ changed: boolean }>("/api/auth/change-password", {
        method: "POST",
        body: JSON.stringify(vars),
      }),
  });
}
